import { Component, Input, OnChanges } from '@angular/core';

import { AttachmentsService }             from './attachments.service';
import { AttachmentModel }                from './typings/attachment';
import { AttachmentThumbnailStatusModel } from './typings/attachment.thumbnail-status';
import { MessagesService }                from '../messages/messages.service';

@Component({
  selector   : 'wor-attachment',
  template: require('./attachment.component.html')
})
export class AttachmentComponent implements OnChanges {
  @Input() attachment: AttachmentModel;

  thumbnailStatus: AttachmentThumbnailStatusModel = {
    isLoading    : true,
    isSuccessful : false,
    percentLoaded: 0
  };

  constructor (
    public  attachmentsService: AttachmentsService,
    private messagesService   : MessagesService
  ) {}

  ngOnChanges () : void {
    if ( this.attachment ) {
      this.attachmentsService.getThumbnails(this.thumbnailStatus, this.attachment)
      .catch(() => undefined);
    }
  }

  showAttachment () : void {
    this.attachmentsService.showAttachment(this.attachment)
    .catch(error => this.messagesService.error(error));
  }
}
